import { IFormRules } from '../../utils/useValidator';

export const fieldRules: IFormRules = {
  name: {
    required: true,
    rules: [],
  },
  pricePerUnit: {
    required: true,
    rules: [],
  },
  categoryId: {
    required: true,
    rules: [],
  },
  description: {
    required: false,
    rules: [],
  },
  billingFrequency: {
    required: true,
    rules: [],
  },
  billingTriggerId: {
    required: false,
    rules: [],
  },
  customBillingTrigger: {
    required: false,
    rules: [],
  },
  recurrentRegularBillingFrequency: {
    required: false,
    rules: [],
  },
  billingFrequencyPeriodForEvery: {
    required: false,
    rules: [],
  },
  every: {
    required: false,
    rules: [],
  },
  quickBooksAccountId: {
    required: true,
    rules: [],
  },
};
